export function getIsCypressRunning(): boolean {
  try {
    return 'Cypress' in window || 'Cypress' in window.parent;
  } catch {
    return false;
  }
}
